import { React, useState, useEffect, useContext, useRef, useCallback } from 'react'
import { Button } from 'bootstrap'
import { faMagnifyingGlass, faPrint, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf, faTrashCan, faFile } from '@fortawesome/free-regular-svg-icons'
import { useSelector, useDispatch } from 'react-redux';
import { faTriangleExclamation, faStar, faCircleInfo, faArrowsRotate, faAnglesDown, faAnglesUp, faXmark, faArrowRight, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, CommonAPIConstants, FilesAPIConstants, InsurancePaymentReportConstants } from '../utilities/Constants'
import * as XLSX from 'xlsx';
import { setUser } from '../redux/actions/userActions'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { FixedSizeList as List } from 'react-window'
import Draggable from 'react-draggable'



const InsPaymentReport = () => {

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Default value for the input is the current date
    const defaultDate = getCurrentDate();
    const defaultFromDate = new Date('2015-01-01');

    const today = new Date();
    const formatCurDate = format(today, 'MM/dd/yyyy');

    const rowsPerPage = 100;

    const [isHideChecked, setIsHideChecked] = useState(false);
    const [updatedTabledata, setUpdatedTableData] = useState([]);
    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(''); // State to store start date
    const [endDate, setEndDate] = useState('');     // State to store end date
    const [loading, setLoading] = useState(false);

    const [selecteSubType, setSelecteSubType] = useState('0');
    const [selectInsType, setSelectInsType] = useState('0');

    const ServiceLocValues = [
        { TextField: 'Office - 11', ValueField: '11' },
        { TextField: 'Home - 12', ValueField: '12' },
        { TextField: 'SUD - 57', ValueField: '57' },
        { TextField: 'Lab - 81', ValueField: '81' },


    ];

    const [ServiceLocations, setServiceLocations] = useState([]);
    const [selectedCMS33a, setSelectedCMS33a] = useState('0');
    const [selectedCMS33b, setSelectedCMS33b] = useState('0');
    const [selectedBillingNPI, setSelectedBillingNPI] = useState('0');
    const [selectedPracticeProvider, setSelectedPracticeProvider] = useState('0');
    const [selectedProvidersCategory, setSelectedProvidersCategory] = useState('0');
    const [selectedSearchFilter, setSelectedSearchFilter] = useState('3');
    const [selectedLocation, setSelectedLocation] = useState('-1');
    const [selectedStatusRadioButton, setSelectedStatusRadioButton] = useState('');
    const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] = useState('0');
    const [selectedServiceLocation, setSelectedServicelocation] = useState('0');
    const [selectedFilterProvider, setSelectedFilterProvider] = useState('0');


    const [locations, setLocations] = useState([]);
    const [cms33aData, setCMS33aData] = useState([]);
    const [cms33bData, setCMS33bData] = useState([]);
    const [providerCategory, setProviderCategory] = useState([]);
    const [searchFilterData, setSearchFilterData] = useState([]);
    const [practiceProvider, setPracticeProvider] = useState([]);
    const [statusRadioButton, setStatusRadioButton] = useState([]);
    const [checkedRadioButton, setCheckedRadioButton] = useState([]);

    const [BillingNPIs, setBillingNPIs] = useState([]);

    const [searchText, setSearchText] = useState('');

    const [suggestions, setSuggestions] = useState([]);

    const [sPatID, setSPatID] = useState('');
    const [sInsID, setSInsID] = useState('');
    const [sClaimStatus, setsClaimStatus] = useState('');


    const [tableDetails, setTableDetails] = useState([]);

    const [selectAllDropdown, setSelectAllDropdown] = useState([]);


    const [selectedRows, setSelectedRows] = useState([]);

    const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
    const [SecInsuranceAllCheckbox, setSecInsuranceAllCheckbox] = useState([]);
    const [filteredTableDetails, setFilteredTableDetails] = useState(tableDetails);


    const [displayedRecords, setDisplayedRecords] = useState([]);
    const [selectedDropdownValue, setSelectedDropdownValue] = useState('AppointmentDate');

    const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [showVerifiedSaveModal, setShowVerifiedSaveModal] = useState(false);
    const [showServiceErrorModal, setShowServiceErrorModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
    const [closeClaimsModal, setCloseClaimsModal] = useState(false);
    const [savedRowCount, setSavedRowCount] = useState(0);
    const [deleteRowCount, setDeleteRowCount] = useState(0);
    const [successTimer, setSuccessTimer] = useState(5000);

    const [appointmentDates, setAppointmentDates] = useState([]);
    const [selectLocationID, setSelectLocationID] = useState('-1');
    const [showFilters, setShowFilters] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    const [claimservices, setClaimServices] = useState([]);
    const [selectedCptValue, setSelectedCptValue] = useState('');
    const [cptValueList, setCptValueList] = useState([]);
    const [selectedCPTCode, setSelectedCPTCode] = useState('');
    const [insOrPatFilter, setInsOrPatFilter] = useState('updatedby');
    const [practiceBillingNPIs, setPracticeBillingNPIs] = useState([]);
    const [selectpracticeBillingNPIs, setSelectPracticeBillingNPIs] = useState('');
    const [selectedViewType, setSelectedViewType] = useState('0');
    const [selectedClaimService, setSelectedClaimService] = useState('0');
    const [isClaimClosed, setIsClaimClosed] = useState('false');

    const [claimFilterRecCountsTableData, setClaimFilterRecCountsTableData] = useState([]);
    const [claimRecCountsTableData, setClaimRecCountsTableData] = useState(claimFilterRecCountsTableData);
    const [defaultUpdatedBy, setDefaultUpdatedBy] = useState('Test Biller');

    const [checkedServices, setCheckedServices] = useState([]);
    const [isNoServiceChecked, setIsNoServiceChecked] = useState(false);

    const [selectedPolicyRows, setSelectedPolicyRows] = useState([]);
    const [selectedInsRows, setSelectedInsRows] = useState([]);
    const [selectedSecInsuranceRows, setSelectedSecInsuranceRows] = useState([]);
    const [selectedAdminWriteRows, setSelectedAdminWriteRows] = useState([]);
    const [selectedWriteOffRows, setSelectedWriteOffRows] = useState([]);
    const [selectedResubmitRows, setSelectedResubmitRows] = useState([]);
    const [transactionCodes, setTransactionCodes] = useState([]);
    const [selectedTransactionCode, setSelectedTransactionCode] = useState('');
    const [verifiedData, setVerifiedData] = useState([]);
    const [selectedVerifiedData, setSelectedVerifiedData] = useState([]);
    const [billingNpiValue, setBillingNpiValue] = useState('');
    const [claimId, setClaimId] = useState('');
    const [cptCode, setCptCode] = useState('');
    const [dos, setDos] = useState('');
    const [savingData, setSavingData] = useState(false);
    const [dataSaved, setDataSaved] = useState(false);
    const [filterType, setFilterType] = useState('all');
    const [claimDOS, setClaimDOS] = useState('');
    const [isTotal, setIsTotal] = useState(false);

    const [isClaimChecked, setIsClaimChecked] = useState(true);
    const [isSubmitChecked, setIsSubmitChecked] = useState(true);
    const [isNonSubmitChecked, setIsNonSubmitChecked] = useState(true);
    const [isSentChecked, setIsSentChecked] = useState(true);
    const [isPaidChecked, setIsPaidChecked] = useState(true);
    const [isRecvdChecked, setIsRecvdChecked] = useState(true);
    const [isDeniedChecked, setIsDeniedChecked] = useState(true);
    const [isRejectedChecked, setIsRejectedChecked] = useState(true);
    const [isForwardChecked, setIsForwardChecked] = useState(true);
    const [isPostedChecked, setIsPostedChecked] = useState(true);

    const [rcvdwriteOffValue, setRcvdWriteOffValue] = useState('0');

    const [claimRecvdChargeValue, setClaimRcvdChargeValue] = useState([]);
    const [claimWriteOffValue, setClaimWriteOffvalue] = useState([]);

    const [claimSecRecvdChargeValue, setSecClaimRcvdChargeValue] = useState([]);

    const [deductibleAmt, setDeductible] = useState([]);
    const [patientRes, setPatientRes] = useState([]);
    const [adjustmentAmt, setAdjustmentAmt] = useState([]);
    const [secPendingAmt, setsecPendingAmt] = useState([]);

    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [cptChequeNumber, setcptChequeNumber] = useState([]);
    const [cptChequeDate, setCptChequeDate] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [checkDate, setCheckDate] = useState('');
    const [formatCheckDate, setFormatCheckDate] = useState('');
    const [claimPayerRefID, setClaimPayerRefID] = useState([]);
    const [claimNotes, setClaimNotes] = useState([]);

    const [cptSecChequeNumber, setcptsecChequeNumber] = useState([]);
    const [cptSecChequeDate, setCptSecChequeDate] = useState([]);
    const [secClaimPayerRefID, setSecClaimPayerRefID] = useState([]);

    const [checkEligibilityColor, setCheckEligibilityColor] = useState('');
    const [isLoading, setIsLoading] = useState('');
    const [isInStatus, setIsInStatus] = useState(false);

    const [payRefColor, setPayRefColor] = useState(false);
    const [activeRow, setActiveRow] = useState(null);
    const [selectedServiceIDs, setSelectedServiceIDs] = useState([]);
    const [prevFilter, setPrevFilter] = useState('');
    const [queryFilter, setQueryFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState(null);
    const [selectedAllChecked, setSelectedAllChecked] = useState(false);
    const [selectAllWriteOffChecked, setSelectAllWriteOffChecked] = useState(false);
    const [selectAllAdminWriteChecked, setSelectAllAdminWriteChecked] = useState(false);
    const [selectAllResubmit, setSelectAllResubmit] = useState(false);
    const [selectedData, setSelectedData] = useState('');
    const [isPageLoad, setisPageLoad] = useState('1');
    const [searchByClaimDos, setSearchByClaimDos] = useState('');

    const [showDataModal, setShowDataModal] = useState(false);
    const [eventData, setEventData] = useState([]);
    const [selectedClaimID, setselectedClaimID] = useState([]);
    const [showFaxModal, setShowFaxModal] = useState(false);

    const [reGenerateData, setReGenerateData] = useState(false);
    const [rowState, setRowState] = useState({});
    const [isHidden, setIsHidden] = useState(false);
    const [selectedPatname, setselectedPatname] = useState('');
    const [selectedDOB, setselectedDOB] = useState('');
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);
    const [searchByLocation, setSearchByLocation] = useState('');
    const [claimID, setClaimID] = useState('');
    const [activeCounts, setActiveCounts] = useState(null);
    const [visibleRecords, setVisibleRecords] = useState(rowsPerPage);
    const [searchByInsuName, setSearchByInsuName] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    const tableContainerRef = useRef(null);


    const sAuthToken = useSelector((state) => state.user.token);

    const loadMoreRecords = useCallback(() => {
        setVisibleRecords((prev) => Math.min(prev + rowsPerPage, displayedRecords.length));
    }, [displayedRecords.length]);


    const handleScroll = useCallback(() => {
        const isAtBottom =
            window.innerHeight + window.scrollY >= document.documentElement.scrollHeight;

        if (isAtBottom) {
            loadMoreRecords();
        }
    }, [loadMoreRecords]);




    useEffect(() => {
        setVisibleRecords(rowsPerPage);
    }, [displayedRecords]);




    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);





    const dispatch = useDispatch();




    const userData = useSelector((state) => state.user.user);


    localStorage.setItem('userData2', JSON.stringify(userData));


    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;








    useEffect(() => {
        document.title = 'Insurance Payment Report'


        const initialCheckedServices = claimservices.map((item) => item.ServiceID);
        setCheckedServices(initialCheckedServices);
        setShowServiceErrorModal(false)
    }, [claimservices]);






    useEffect(() => {
        let timerId;


        if (showSuccessModal || deleteSuccessModal) {
            // Start the timer when the success modal is shown
            timerId = setTimeout(() => {
                setShowSuccessModal(false);
                setDeleteSuccessModal(false);
                setShowServiceErrorModal(false);

            }, successTimer);
        }


        return () => {
            clearTimeout(timerId);
        };
    }, [showSuccessModal, successTimer, deleteSuccessModal]);


    const modalRef = useRef(null);





    useEffect(() => {

        const handleOutsideClick = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowConfirmSaveModal(false);
            }
        };

        // Add event listener
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);





    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);
            setIsStartOpen(false)

        } else {
            setStartDate(null);
        }
    };


    const handleEndDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);

            setIsEndOpen(false)

        } else {
            setEndDate(null);
        }
    };



    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };








    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);

            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };



    // Styled via .hv-cal-header / .hv-cal-nav-btn / .hv-cal-select, shared in
    // styles/healthiva/_forms.scss — one header renderer instead of a
    // duplicated inline closure per DatePicker.
    const renderCalendarHeader = ({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
        const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
        const selectedMonth = selectedDate.getMonth();
        const selectedYear = selectedDate.getFullYear();

        return (
            <div className="hv-cal-header">
                <button type="button" className="hv-cal-nav-btn" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                    {"<"}
                </button>
                <select
                    className="hv-cal-select"
                    value={selectedMonth}
                    onChange={({ target: { value } }) => changeMonth(Number(value))}
                >
                    {getMonths(selectedYear)}
                </select>
                <select
                    className="hv-cal-select"
                    value={selectedYear}
                    onChange={({ target: { value } }) => changeYear(Number(value))}
                >
                    {Array.from({ length: 100 }, (v, k) => (
                        <option key={k} value={new Date().getFullYear() - k}>
                            {new Date().getFullYear() - k}
                        </option>
                    ))}
                </select>
                <button type="button" className="hv-cal-nav-btn" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                    {">"}
                </button>
            </div>
        );
    };

    const makeCalContainer = (which) => ({ children }) => (
        <div className="hv-cal-container">
            {children}
            <div className="hv-cal-footer">
                <button type="button" className="today-btn" onClick={() => handleTodayClick(which)}>
                    Today
                </button>
            </div>
        </div>
    );








    useEffect(() => {

        getProvider();
    }, []);



    const getProvider = () => {


        var jsonOBJ = {
            PracticeID: userPracticeID,
            SearchByRole: 0
        }

        var sInputJSON = JSON.stringify(jsonOBJ);


        const url =
            APIConstants.COMMON_BASE_URL +
            `CommonData/GetPracticeProviders?sJSONInput=${sInputJSON}`;
        console.log("URL", url);

        const response = fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${sAuthToken}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {


                console.log("Providers>>>>>>", data);
                setPracticeProvider(Array.isArray(data) ? data : []);

            })

            .catch((error) => {
                console.error("Error fetching data: ", error);
            });
    };



    useEffect(() => {
        if (
            isPageLoad &&
            startDate &&
            endDate &&
            !hasLoadedInitially.current
        ) {
            handleGetInsurancePaymentReport();
            hasLoadedInitially.current = true;
        }
    }, [isPageLoad, startDate, endDate]);



    const formatDate = (date) => {
        return date.toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
        });
    };

    useEffect(() => {
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);

        const formattedStart = formatDate(sevenDaysAgo);
        const formattedEnd = formatDate(today);

        setStartDate(formattedStart);
        setEndDate(formattedEnd);

        setSearchText(userData.userFullName);
        setSPatID(userData.userID);
        setSInsID(userData.userID);
        setisPageLoad(1);
    }, []);




    //Bind the table details



    const handleGetInsurancePaymentReport = async () => {
        setLoading(true);

        var objInput = {
            sProviderID: selectedPracticeProvider,
            sDateType: selectedDropdownValue,
            sClaimSubType: selecteSubType,
            sFromDate: startDate,
            sToDate: endDate,
            iInsType: selectInsType,
            sPracticeID: userPracticeID

        }

        var sInputJSON = JSON.stringify(objInput);


        const url = `${APIConstants.BASE_URL_BILLING}${InsurancePaymentReportConstants.GetInsurancePaymentReport}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)

                setTimeout(() => {
                    setLoading(false);
                    setTableDetails(parsedData);
                    setFilteredTableDetails(parsedData);
                }, 100);
                console.log("Response of" + InsurancePaymentReportConstants.GetInsurancePaymentReport, tableDetails);




            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }




    const handleInsTypeChange = (value) => {
        setSelectInsType(value);
        handleGetInsurancePaymentReport();
    };



    useEffect(() => {
        handleGetInsurancePaymentReport();
    }, [selectInsType]);



    const hasLoadedInitially = useRef(false);







    const removeHtmlTags = (htmlString) => {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlString;
        return tempElement.textContent || tempElement.innerText;
    };



    const getClassForClaimStatus = (claimStatusFlag) => {
        const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);
        switch (cleanClaimStatusFlag) {
            case 'N':
                return 'not-submit-style';
            case 'D':
                return 'denied-style';
            case 'P':
                return 'paid-style';
            case 'F':
                return 'forwarded-style';
            case 'R':
                return 'rejected-style';
            default:
                return '';
        }
    };

    const getTitleForClaimStatus = (claimStatusFlag) => {
        const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);
        switch (cleanClaimStatusFlag) {
            case 'N':
                return 'Not-Billed';
            case 'D':
                return 'Denied';
            case 'P':
                return 'Paid';
            case 'F':
                return 'Forwarded';
            case 'R':
                return 'Rejected';
            default:
                return '';
        }
    };








    const handleOpenModal = () => {


        setShowConfirmSaveModal(true);

    };







    const handleCloseModals = () => {
        // Close all modals

        setShowConfirmSaveModal(false);

        setShowVerifiedSaveModal(false);
        setShowSelectErrorModal(false);
        setCloseClaimsModal(false);
        setShowServiceErrorModal(false);
        setShowFaxModal(false);
        setShowDataModal(false)

    };

    const handleOpenDeleteModal = () => {
        if (selectedRows.length === 0) {


            setShowSelectErrorModal(true);
        } else {


            setShowDeleteModal(true);
        }
    };





    const handleDelete = () => {

        const updatedRows = tableDetails.filter((row, index) => !selectedRows.includes(index));

        setTableDetails(updatedRows);


        setShowDeleteModal(false)
        setDeleteSuccessModal(true)
        setSelectedRows([]);
        setDeleteRowCount(selectedRows.length);
    };








    function getAppLoactionLabelClass(appLocationName) {
        if (appLocationName === 'TP1' || appLocationName === 'TL3') {
            return 'applocation';
        } else if (appLocationName === 'Sec') {
            return 'applocation2';
        } else if (appLocationName === 'NE') {
            return 'applocation3';
        }
        else if (appLocationName === 'SUB') {
            return 'applocation4';
        }
        else if (appLocationName === 'Location Vijaya' || appLocationName === 'Tnl') {
            return 'applocation5';
        }
        else {
            return '';
        }


    }



    function getRecievedChargeClass(recievedCharge) {
        if (recievedCharge === 0) {
            return 'nonpaid-claims';
            // } else if (recievedCharge === "") {
            //   return 'paid-claims';
        } else {
            return '';
        }


    }








    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const closeFilters = () => {
        setShowFilters(false);
    };

    const toggleDetails = () => {
        setShowDetails(!showDetails);
    };

    const formatDOSDate = (dateString) => {


        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    };


    const formatSubmitDate = (dateString) => {
        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    };






    const handleInputClick = () => {
        setIsFocused(true);
    };



    const handleRowClick = (index) => {
        setActiveRow(index);
    };



    const getVerifiedBy = (name) => {
        if (!name) {
            return ''; // Return an empty string if 'name' is undefined
        }

        return name
            .split(" ")
            .map((word) => (word[0] ? word[0].toUpperCase() : ''))
            .join("");
    };








    const handlePrint = () => {
        if (tableRef.current) {


            const tableHTML = tableRef.current.outerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.writeln(`
            <html>
              <head>
                <title class="print-title">Insurance Payment Report</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    margin: 10px;
                    font-size: 15px;
                    color: #000;
                  }
      
                  .print-title {
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                    color: #1a9b8c;
                  }
      
                  .table-container {
                    width: 100%;
                    overflow-x: auto;
                  }
      
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: auto; 
                    word-wrap: break-word;
                  }
      
                  th, td {
                    border: 1px solid black;
                    padding: 5px;
                    text-align: left;
                    font-size: 14px;
                  }
      
                  th {
                    background-color: #f4f4f4;;
                    font-size: 14px;
                    color: black !important;
                    border: 1px solid black;
                    text-align: top;
                    transform-origin: left bottom;
                    height: 120px;
                    
                  }
                  td{
                      font-size:14px
                    }
      
                  @media print {
                    @page {
                      size: A4 landscape;
                      margin: 10mm;
                    }
      
                    .table-container {
                      overflow: visible !important;
                    }
      
                     .hide-on-print {
                      display: none !important;
                    }
      
                    
                    .input{
                      width: 20px !important;
                      color: black;
                      
                    }

                     .input-date{
                      width: 70px !important;
                      color: black;
                      
                    }

                   
                    .show-on-print {
                        width: 30px;
                    }

                    .print-label {

                       display: inline-block;
                        max-width: 40px; 
                        word-wrap: break-word;
                        white-space: normal !important;
                        overflow-wrap: break-word;
                        font-size: 12px;
                     }
                  }
      
                  body {
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
               
                <div class="table-container">${tableHTML}</div>
                <script>
                  window.onload = function() {
                    window.print();
                  };
                  window.onafterprint = function() {
                    window.close();
                  };
                </script>
              </body>
            </html>
          `);

            printWindow.document.close();
        } else {
            console.error("Table reference is not set.");
        }
    };




    const tableRef = useRef('');


    const exportToExcel = () => {
        const pagename = 'InsurancePaymentReport';
        const table = tableRef.current;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);


        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {

                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');

                }
            })
            .catch(error => {
                console.error('Export to Excel failed', error);
            });
    };





    const exportToPDF = () => {
        const pagename = 'InsurancePaymentReport';
        const table = tableRef.current.parentNode;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);


        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {


                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');


                }
            })
            .catch(error => {
                console.error('Export to PDF failed', error);
            });
    };



    const handleLinkClick = (item) => {
        const url = `/#/ClaimStatus/${item.InsID}?startDate=${startDate}&endDate=${endDate}&InsName=${encodeURIComponent(item.Insurance)}&selectedSearchFilter=ins`;
        window.open(url, '_blank');
    };







    const handleSort = (key, accessor) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const sortedData = [...displayedRecords].sort((a, b) => {
            let aValue = accessor ? accessor(a) : a[key];
            let bValue = accessor ? accessor(b) : b[key];


            if (aValue == null) aValue = 0;
            if (bValue == null) bValue = 0;


            if (key.toLowerCase().includes('date') || key.toLowerCase().includes('dob') || key.toLowerCase().includes('dos')) {
                aValue = new Date(aValue);
                bValue = new Date(bValue);
            }

            else if (!isNaN(aValue) && !isNaN(bValue)) {
                aValue = parseFloat(aValue) || 0;
                bValue = parseFloat(bValue) || 0;
            }

            else if (typeof aValue === 'string') {
                aValue = aValue.toUpperCase();
                bValue = typeof bValue === 'string' ? bValue.toUpperCase() : '';
            }

            if (aValue < bValue) return direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        setSortConfig({ key, direction });
        setDisplayedRecords(sortedData);
    };




    useEffect(() => {
        const filteredData = tableDetails.filter(item =>
            item.Insurance && typeof item.Insurance === 'string'
                ? item.Insurance.toLowerCase().includes(searchByInsuName.toLowerCase())
                : true
        );

        setFilteredTableDetails(filteredData);
    }, [searchByInsuName, tableDetails]);



    const getValue = (val, index) => {
        const parts = val?.split('-') || [];
        const raw = parts[selecteSubType === '0' ? 0 : 1];
        return Number(raw) || 0;
    };

    const totals = {
        ALL_CLAIMS: 0,
        SUB: 0,
        NONSUB: 0,
        PAID: 0,
        REJECTED: 0,
        DENIED: 0,
        SENT_CLAIMS: 0,
        FORWARDED: 0,
        OTHER: 0
    };

    tableDetails.forEach(item => {
        totals.ALL_CLAIMS += getValue(item.ALL_CLAIMS);
        totals.SUB += getValue(item.SUB);
        totals.NONSUB += getValue(item.NONSUB);
        totals.PAID += getValue(item.PAID);
        totals.REJECTED += getValue(item.REJECTED);
        totals.DENIED += getValue(item.DENIED);
        totals.SENT_CLAIMS += getValue(item.SENT_CLAIMS);
        totals.FORWARDED += getValue(item.FORWARDED);
        totals.OTHER += getValue(item.OTHER);
    });


    const formatTotal = (value) => {
        const num = parseFloat(value) || 0;
        return selecteSubType === '0' ? `$${num.toFixed(2)}` : num;
    };



    return (
        <>

            <div className="hv-page">
                <div className="hv-container">

                    <header className="hv-pagehead">
                        <h1 className="hv-pagehead__title">Insurance Payment Report</h1>
                    </header>

                    <section className="hv-toolbar" aria-label="Filters">

                        <div className="hv-toolbar__group">
                            <label className="hv-field__label" onClick={getProvider}>Provider:</label>

                            <select
                                className="hv-select"
                                value={selectedPracticeProvider}
                                onChange={(e) =>
                                    setSelectedPracticeProvider(e.target.value)}
                            >
                                <option value="0">{userData.practiceName}</option>

                                {practiceProvider?.map((item, index) => (
                                    <option value={item.ProviderID} key={index}>
                                        {item.ProviderName}
                                    </option>
                                ))}
                            </select>

                            <select
                                className="hv-select"
                                value={selectedDropdownValue}
                                onChange={(e) => setSelectedDropdownValue(e.target.value)}
                            >
                                <option value="AppointmentDate">DOS</option>
                                <option value="SubmitDate">Submit Date</option>
                            </select>
                        </div>

                        <div className="hv-toolbar__group">
                            <label className="hv-field__label">From:</label>
                            <DatePicker
                                selected={startDate ? new Date(startDate) : null}
                                onChange={handleStartDateChange}
                                dateFormat="MM/dd/yyyy"
                                maxDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                yearDropdownItemNumber={100}
                                readOnly={isHideChecked}
                                className="hv-date"
                                placeholderText="MM/dd/yyyy"
                                calendarContainer={makeCalContainer("start")}
                                open={isStartOpen}
                                onFocus={() => setIsStartOpen(true)}
                                onInputClick={() => setIsStartOpen(true)}
                                onClickOutside={() => setIsStartOpen(false)}
                                renderCustomHeader={renderCalendarHeader}
                            />

                            <label className="hv-field__label">To:</label>
                            <DatePicker
                                selected={endDate ? new Date(endDate) : null}
                                onChange={handleEndDateChange}
                                dateFormat="MM/dd/yyyy"
                                maxDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                yearDropdownItemNumber={100}
                                className="hv-date"
                                placeholderText="MM/dd/yyyy"
                                popperPlacement="bottom-start"
                                readOnly={isHideChecked}
                                calendarContainer={makeCalContainer("end")}
                                open={isEndOpen}
                                onFocus={() => setIsEndOpen(true)}
                                onInputClick={() => setIsEndOpen(true)}
                                onClickOutside={() => setIsEndOpen(false)}
                                renderCustomHeader={renderCalendarHeader}
                            />

                            <button type="button" className="hv-icon-btn" title="Search" onClick={handleGetInsurancePaymentReport}>
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </button>
                        </div>

                        <div className="hv-seg">
                            <label className={`hv-seg__btn${selecteSubType === '0' ? ' is-active' : ''}`}>
                                <input
                                    className="hv-sr-only"
                                    type="radio"
                                    name="option"
                                    value="0"
                                    checked={selecteSubType === '0'}
                                    onChange={(e) => setSelecteSubType(e.target.value)}
                                />
                                Charges
                            </label>
                            <label className={`hv-seg__btn${selecteSubType === '1' ? ' is-active' : ''}`}>
                                <input
                                    className="hv-sr-only"
                                    type="radio"
                                    name="option"
                                    value="1"
                                    checked={selecteSubType === '1'}
                                    onChange={(e) => setSelecteSubType(e.target.value)}
                                />
                                Count
                            </label>
                        </div>

                        <div className="hv-seg">
                            <label className={`hv-seg__btn${selectInsType === '0' ? ' is-active' : ''}`}>
                                <input
                                    className="hv-sr-only"
                                    type="radio"
                                    name="insTypeOption"
                                    value="0"
                                    checked={selectInsType === '0'}
                                    onChange={(e) => handleInsTypeChange(e.target.value)}
                                />
                                All
                            </label>
                            <label className={`hv-seg__btn${selectInsType === '1' ? ' is-active' : ''}`}>
                                <input
                                    className="hv-sr-only"
                                    type="radio"
                                    name="insTypeOption"
                                    value="1"
                                    checked={selectInsType === '1'}
                                    onChange={(e) => handleInsTypeChange(e.target.value)}
                                />
                                Primary
                            </label>
                            <label className={`hv-seg__btn${selectInsType === '2' ? ' is-active' : ''}`}>
                                <input
                                    className="hv-sr-only"
                                    type="radio"
                                    name="insTypeOption"
                                    value="2"
                                    checked={selectInsType === '2'}
                                    onChange={(e) => handleInsTypeChange(e.target.value)}
                                />
                                Secondary
                            </label>
                        </div>

                        <span className="hv-spacer" />

                        <span className="hv-exports">
                            <button type="button" className="hv-icon-btn hv-tip" data-tip="Print" onClick={handlePrint}>
                                <FontAwesomeIcon icon={faPrint} />
                            </button>
                            <button type="button" className="hv-icon-btn hv-tip hv-t-green" data-tip="Excel" onClick={exportToExcel}>
                                <FontAwesomeIcon icon={faFileExcel} />
                            </button>
                            <button type="button" className="hv-icon-btn hv-tip hv-t-red" data-tip="PDF" onClick={exportToPDF}>
                                <FontAwesomeIcon icon={faFilePdf} />
                            </button>
                        </span>

                    </section>

                    {loading && (
                        <div className="hv-loading-overlay">
                            <div className="hv-spinner" role="status" aria-label="Loading" />
                        </div>
                    )}

                    <section className="hv-panel hv-panel--flush">
                        <div className="hv-table-scroll">
                            <table className="hv-table" ref={tableRef}>

                                <thead>
                                    <tr>
                                        <th className="hv-th-group--brand">#</th>

                                        <th className="hv-th-group--brand">
                                            <div className="hv-th-title">Insurance</div>
                                            <input
                                                className="hv-th-search w-50"
                                                type="text"
                                                placeholder="Search"
                                                value={searchByInsuName}
                                                onChange={(e) => setSearchByInsuName(e.target.value)}
                                            />
                                        </th>

                                        <th className="hv-th-group--neutral">All Claims</th>
                                        <th className="hv-th-group--neutral">SUBMITTED</th>
                                        <th className="hv-th-group--neutral">NON-SUBMITTED</th>

                                        <th className="hv-th-group--warn">PAID</th>
                                        <th className="hv-th-group--warn">REJECTED</th>
                                        <th className="hv-th-group--warn">DENIED</th>
                                        <th className="hv-th-group--warn">SENT</th>
                                        <th className="hv-th-group--warn">FORWARDED</th>
                                        <th className="hv-th-group--warn">OTHER</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredTableDetails.map((item, index) => (
                                        <tr
                                            className={activeRow === index ? "is-selected" : ""}
                                            key={index}
                                            onClick={() => handleRowClick(index)}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <button type="button" className="hv-td-link" onClick={() => handleLinkClick(item)}>
                                                    {item.Insurance}
                                                </button>
                                            </td>

                                            <td>
                                                {selecteSubType === '0' ? `$${item.ALL_CLAIMS?.split('-')[0]}` : item.ALL_CLAIMS?.split('-')[1]}
                                            </td>
                                            <td>
                                                {selecteSubType === '0' ? `$${item.SUB?.split('-')[0]}` : item.SUB?.split('-')[1]}
                                            </td>
                                            <td>
                                                {selecteSubType === '0' ? `$${item.NONSUB?.split('-')[0]}` : item.NONSUB?.split('-')[1]}
                                            </td>
                                            <td>
                                                {selecteSubType === '0' ? `$${item.PAID?.split('-')[0]}` : item.PAID?.split('-')[1]}
                                            </td>
                                            <td>
                                                {selecteSubType === '0' ? `$${item.REJECTED?.split('-')[0]}` : item.REJECTED?.split('-')[1]}
                                            </td>
                                            <td>
                                                {selecteSubType === '0' ? `$${item.DENIED?.split('-')[0]}` : item.DENIED?.split('-')[1]}
                                            </td>
                                            <td>
                                                {selecteSubType === '0' ? `$${item.SENT_CLAIMS?.split('-')[0]}` : item.SENT_CLAIMS?.split('-')[1]}
                                            </td>
                                            <td>
                                                {selecteSubType === '0' ? `$${item.FORWARDED?.split('-')[0]}` : item.FORWARDED?.split('-')[1]}
                                            </td>
                                            <td>
                                                {selecteSubType === '0' ? `$${item.OTHER?.split('-')[0]}` : item.OTHER?.split('-')[1]}
                                            </td>
                                        </tr>
                                    ))}

                                    <tr className="hv-tr-total">
                                        <td colSpan={2}>Total</td>
                                        <td>{formatTotal(totals.ALL_CLAIMS)}</td>
                                        <td>{formatTotal(totals.SUB)}</td>
                                        <td>{formatTotal(totals.NONSUB)}</td>
                                        <td>{formatTotal(totals.PAID)}</td>
                                        <td>{formatTotal(totals.REJECTED)}</td>
                                        <td>{formatTotal(totals.DENIED)}</td>
                                        <td>{formatTotal(totals.SENT_CLAIMS)}</td>
                                        <td>{formatTotal(totals.FORWARDED)}</td>
                                        <td>{formatTotal(totals.OTHER)}</td>
                                    </tr>
                                </tbody>

                            </table>
                        </div>
                    </section>






                    {showServiceErrorModal && (
                        <>
                            <div className="hv-scrim" onClick={handleCloseModals} />
                            <div className="hv-modal">
                                <div className="hv-modal__box">
                                    <div className="hv-modal__head hv-modal__head--warn">
                                        <span className="hv-modal__title">Selection required</span>
                                        <button className="hv-modal__close" onClick={handleCloseModals}>
                                            <FontAwesomeIcon icon={faXmark} />
                                        </button>
                                    </div>
                                    <div className="hv-modal__body">
                                        <p>please select atleast one Filter from Service...</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {showSelectErrorModal && (
                        <>
                            <div className="hv-scrim" onClick={handleCloseModals} />
                            <div className="hv-modal">
                                <div className="hv-modal__box">
                                    <div className="hv-modal__head hv-modal__head--warn">
                                        <span className="hv-modal__title">Selection required</span>
                                        <button className="hv-modal__close" onClick={handleCloseModals}>
                                            <FontAwesomeIcon icon={faXmark} />
                                        </button>
                                    </div>
                                    <div className="hv-modal__body">
                                        <p>please select atleast one claim...</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {showSuccessModal && (
                        <>
                            <div className="hv-scrim" onClick={handleCloseModals} />
                            <div className="hv-modal">
                                <div className="hv-modal__box">
                                    <div className="hv-modal__head hv-modal__head--ok">
                                        <span className="hv-modal__title">Success</span>
                                        <button className="hv-modal__close" onClick={handleCloseModals}>
                                            <FontAwesomeIcon icon={faXmark} />
                                        </button>
                                    </div>
                                    <div className="hv-modal__body">
                                        <p>Selected Claim Successfully Closed</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {showDataModal && (
                        <Draggable>
                            <div className="hv-panel" style={{ position: 'absolute', top: '70%', left: '30%', width: 'auto', minWidth: '460px', zIndex: 1000 }}>
                                <div className="hv-panel__head">
                                    <span className="hv-t-bold">
                                        Patient Name: <span className="hv-t-teal hv-t-bold">{selectedPatname}</span>
                                    </span>
                                    <span className="hv-t-semi" style={{ marginLeft: '30px' }}>DOB: {selectedDOB}</span>
                                    <button type="button" className="hv-modal__close" style={{ marginLeft: 'auto' }} onClick={handleCloseModals}>
                                        <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                </div>
                                <div className="hv-table-scroll">
                                    <table className="hv-table">
                                        <thead>
                                            <tr>
                                                <th className="hv-th-group--brand" style={{ width: '30px' }}>#</th>
                                                <th className="hv-th-group--brand">Claim ID</th>
                                                <th className="hv-th-group--brand">DOS</th>
                                                <th className="hv-th-group--brand">Submit Date</th>
                                                <th className="hv-th-group--brand">Submit By</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </Draggable>
                    )}











                </div>


            </div>




        </>
    )
}

export default InsPaymentReport;